import { render } from "./Sku.vue?vue&type=template&id=1bb2cca0"
import script from "./Sku.vue?vue&type=script&lang=js"
export * from "./Sku.vue?vue&type=script&lang=js"

import "./Sku.vue?vue&type=style&index=0&id=1bb2cca0&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__